import { ProductType } from '@general/js/enums';
import { OperationType } from '@/enums';

// eslint-disable-next-line import/prefer-default-export
export const mapProductListObj = (initialProductList, newProductList, initialExcess, newExcess) => {
  const productList = [];
  const newProducts = newProductList.products.map((product) => {
    // Add isSame field, and true for the productCode is same with existing one
    const isSame = !!initialProductList.products.find((oldProduct) => {
      return oldProduct.productCode === product.productCode;
    });
    if (product.productType.toLowerCase() !== ProductType.EXTRAS_ONLY) {
      return {
        productCode: product.productCode,
        productExcess: newExcess,
        productExcessType: product.productExcessType,
        productType: product.productType,
        isSame,
      };
    }
    return {
      productCode: product.productCode,
      productType: product.productType,
      isSame,
    };
  });

  // replace would only happen when productCode is exiting product's code for hospital but different excess amount
  const sameHospitalProduct = newProducts.find((product) => {
    return product.isSame === true && product.productType.toLowerCase() !== ProductType.EXTRAS_ONLY;
  });

  const restProducts = newProducts.filter((product) => {
    if (sameHospitalProduct != null) {
      return product.productCode !== sameHospitalProduct.productCode;
    }
    return true;
  });

  if (sameHospitalProduct !== undefined) {
    if (sameHospitalProduct.productExcess !== initialExcess) {
      productList.push({
        op: OperationType.REPLACE,
        productCode: sameHospitalProduct.productCode,
        excess: sameHospitalProduct.productExcess,
        productExcessType: sameHospitalProduct.productExcessType,
      });
    } else {
      productList.push({ op: OperationType.NONE, productCode: sameHospitalProduct.productCode });
    }
  }
  if (restProducts != null) {
    restProducts.forEach((product) => {
      if (product.productType.toLowerCase() === ProductType.EXTRAS_ONLY) {
        if (product.isSame) {
          productList.push({
            op: OperationType.NONE,
            productCode: product.productCode,
          });
        } else {
          productList.push({
            op: OperationType.ADD,
            productCode: product.productCode,
          });
        }
      } else {
        productList.push({
          op: OperationType.ADD,
          productCode: product.productCode,
          excess: product.productExcess,
          productExcessType: product.productExcessType,
        });
      }
    });
  }

  return productList;
};
